import { Badge, Highlight } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { StackOrModal } from "../../../../../mantine/components/StackOrModal/StackOrModal";
import type { PPAContract } from "../../PPAContractPage.types";

export function getGenerationSitesColumn(
  contracts: Array<PPAContract>
): MRT_ColumnDef<PPAContract> {
  const usedGenerationSites = contracts
    .map((contract) => contract.generation_sites)
    .flat();
  const usedGenerationSitesSet = Array.from<string>(
    new Set(usedGenerationSites)
  );
  const uniqueUsedGenerationSites = Array.from(usedGenerationSitesSet).sort();

  return {
    accessorKey: "generation_sites",
    header: "Erzeugungsstandort",
    enableSorting: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedGenerationSites
    },
    size: 210,
    filterFn: "arrIncludesSome",
    Cell: ({ table, row }) => {
      const search = table.getState().globalFilter ?? "";

      return (
        <StackOrModal
          elementText="Erzeugungsstandorte"
          numElements={row.original.generation_sites.length}
        >
          {row.original.generation_sites.map((site) => (
            <Badge color="gray" key={site} variant="outline">
              <Highlight highlight={search}>{site}</Highlight>
            </Badge>
          ))}
        </StackOrModal>
      );
    }
  };
}
